var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00008 11.8334C2.77842 11.8334 0.166748 9.22168 0.166748 6.00002C0.166748 2.77836 2.77842 0.166687 6.00008 0.166687C9.22174 0.166687 11.8334 2.77836 11.8334 6.00002C11.8299 9.22022 9.22028 11.8298 6.00008 11.8334ZM1.33341 6.10035C1.36102 8.66774 3.45739 10.7306 6.0249 10.7169C8.5924 10.703 10.6665 8.61773 10.6665 6.05019C10.6665 3.48265 8.5924 1.39739 6.0249 1.38352C3.45739 1.36979 1.36102 3.43263 1.33341 6.00002V6.10035ZM6.58342 8.91669H5.41675V6.58335H3.08342V5.41669H5.41675V3.08335H6.58342V5.41669H8.91675V6.58335H6.58342V8.91669Z",
    fill: "#161F3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.dec8a8d2.svg";
export { ForwardRef as ReactComponent };